import { useState } from 'react';

import SupportFab from '../Support/SupportFab';
import ScrollToTopButton from '../UI/ScrollToTopButton';
import ClockWidgetMount from './ClockWidgetMount';
import TalentAdaptiveShellFrame from './TalentAdaptiveShellFrame';

export default function TalentAdaptiveShell(props) {
  const [supportFabOpen, setSupportFabOpen] = useState(false);

  return (
    <>
      <TalentAdaptiveShellFrame {...props} />
      <ScrollToTopButton hidden={supportFabOpen} />
      <SupportFab onOpenChange={setSupportFabOpen} />
      <ClockWidgetMount />
    </>
  );
}
